(function () {
  var categoryOrder = [
    "All",
    "Soccer",
    "Basketball",
    "Baseball",
    "NFL",
    "Racing",
    "Wrestling",
    "UFC",
    "Pokemon/TCG",
    "Hockey",
    "Other"
  ];

  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function monthKey(date) {
    return date.getFullYear() + "-" + pad(date.getMonth() + 1);
  }

  function dateKey(date) {
    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
  }

  function parseReleaseDate(value) {
    if (!value) return null;
    var parts = String(value).split("-").map(function (part) { return Number(part); });
    if (parts.length !== 3 || parts.some(function (part) { return !Number.isFinite(part); })) return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function dateLabel(date) {
    return dayNames[date.getDay()] + " " + date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
  }

  function monthLabel(date) {
    return monthNames[date.getMonth()] + " " + date.getFullYear();
  }

  function monthKeyFromRelease(release) {
    var parsed = parseReleaseDate(release.releaseDate);
    if (parsed) return monthKey(parsed);
    return release.monthKey || "";
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalise(value) {
    return String(value || "").toLowerCase();
  }

  function formatUpdated(value) {
    if (!value) return "Last updated: awaiting first successful sync";
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Last updated: " + value;
    return "Last updated: " + date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  function categoryMatches(activeCategory, release) {
    return activeCategory === "All" || release.category === activeCategory;
  }

  function searchMatches(query, release) {
    if (!query) return true;
    var haystack = [
      release.title,
      release.brand,
      release.category,
      release.dateLabel
    ].map(normalise).join(" ");
    return haystack.indexOf(query) !== -1;
  }

  function ctaForRelease(release, contactUrl) {
    if (release.shopifyProduct && release.shopifyProduct.url) {
      var available = release.shopifyProduct.available !== false;
      return {
        label: available ? "Shop now" : "Pre-order",
        className: available ? "scw-release-calendar__button--primary" : "scw-release-calendar__button--preorder",
        url: release.shopifyProduct.url
      };
    }

    var joiner = contactUrl.indexOf("?") === -1 ? "?" : "&";
    return {
      label: "Notify interest",
      className: "scw-release-calendar__button--interest",
      url: contactUrl + joiner + "release_interest=" + encodeURIComponent(release.title || "")
    };
  }

  function renderCategories(root, releases, activeCategory, onSelect) {
    var holder = root.querySelector("[data-scw-calendar-categories]");
    var available = new Set(["All"]);
    releases.forEach(function (release) {
      if (release.category) available.add(release.category);
    });

    holder.innerHTML = categoryOrder
      .filter(function (category) { return available.has(category); })
      .map(function (category) {
        return '<button type="button" class="scw-release-calendar__category" aria-pressed="' +
          String(category === activeCategory) + '" data-category="' + escapeHtml(category) + '">' +
          escapeHtml(category) +
          "</button>";
      })
      .join("");

    holder.querySelectorAll("button").forEach(function (button) {
      button.addEventListener("click", function () {
        onSelect(button.getAttribute("data-category") || "All");
      });
    });
  }

  function renderRelease(release, contactUrl) {
    var cta = ctaForRelease(release, contactUrl);
    var product = release.shopifyProduct || {};
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(release.title) + '" loading="lazy">'
      : '<span class="scw-release-calendar__thumb-placeholder" aria-hidden="true">SCW</span>';
    var dateText = release.releaseDate ? release.dateLabel : "Date TBC";

    return [
      '<article class="scw-release-calendar__card">',
      '<div class="scw-release-calendar__thumb">' + image + "</div>",
      '<div class="scw-release-calendar__copy">',
      '<h3 class="scw-release-calendar__name">' + escapeHtml(release.title) + "</h3>",
      '<div class="scw-release-calendar__meta">',
      '<span class="scw-release-calendar__tag scw-release-calendar__tag--date">' + escapeHtml(dateText) + "</span>",
      release.brand ? '<span class="scw-release-calendar__tag">' + escapeHtml(release.brand) + "</span>" : "",
      release.category ? '<span class="scw-release-calendar__tag">' + escapeHtml(release.category) + "</span>" : "",
      "</div>",
      "</div>",
      '<a class="scw-release-calendar__button ' + cta.className + '" href="' + escapeHtml(cta.url) + '">' + escapeHtml(cta.label) + "</a>",
      "</article>"
    ].join("");
  }

  function render(root, state) {
    var month = monthKey(state.visibleMonth);
    var query = normalise(state.query);
    var list = root.querySelector("[data-scw-calendar-list]");
    var status = root.querySelector("[data-scw-calendar-status]");
    var monthHeading = root.querySelector("[data-scw-calendar-month]");
    var count = root.querySelector("[data-scw-calendar-count]");
    var today = dateKey(new Date());

    var releases = state.releases
      .filter(function (release) { return release.isRelevant !== false; })
      .filter(function (release) { return monthKeyFromRelease(release) === month; })
      .filter(function (release) { return categoryMatches(state.activeCategory, release); })
      .filter(function (release) { return searchMatches(query, release); })
      .sort(function (a, b) {
        var aDate = a.releaseDate || "9999-99-99";
        var bDate = b.releaseDate || "9999-99-99";
        if (aDate !== bDate) return aDate.localeCompare(bDate);
        return String(a.title || "").localeCompare(String(b.title || ""));
      });

    monthHeading.textContent = monthLabel(state.visibleMonth);
    count.textContent = releases.length === 1 ? "1 release" : releases.length + " releases";
    status.textContent = "";

    if (!releases.length) {
      list.innerHTML = '<div class="scw-release-calendar__empty">No matching releases for this month.</div>';
      return;
    }

    var groups = [];
    releases.forEach(function (release) {
      var key = release.releaseDate || "tbc";
      var group = groups.find(function (item) { return item.key === key; });
      if (!group) {
        group = { key: key, releases: [] };
        groups.push(group);
      }
      group.releases.push(release);
    });

    list.innerHTML = groups.map(function (group) {
      var parsed = group.key === "tbc" ? null : parseReleaseDate(group.key);
      var label = parsed ? dateLabel(parsed) : "Date TBC";
      var kicker = parsed && dateKey(parsed) === today ? "Today" : (parsed ? monthLabel(parsed) : monthLabel(state.visibleMonth));
      return [
        '<section class="scw-release-calendar__day">',
        '<div class="scw-release-calendar__date">',
        '<p class="scw-release-calendar__date-kicker">' + escapeHtml(kicker) + "</p>",
        '<h3 class="scw-release-calendar__date-heading">' + escapeHtml(label) + "</h3>",
        "</div>",
        '<div class="scw-release-calendar__cards">',
        group.releases.map(function (release) { return renderRelease(release, state.contactUrl); }).join(""),
        "</div>",
        "</section>"
      ].join("");
    }).join("");
  }

  function init(root) {
    var dataUrl = root.getAttribute("data-data-url");
    var contactUrl = root.getAttribute("data-contact-url") || "/pages/contact";
    var visibleMonth = new Date();
    visibleMonth.setDate(1);
    var state = {
      activeCategory: "All",
      contactUrl: contactUrl,
      query: "",
      releases: [],
      visibleMonth: visibleMonth
    };

    var search = root.querySelector("[data-scw-calendar-search]");
    var updated = root.querySelector("[data-scw-calendar-updated]");
    var status = root.querySelector("[data-scw-calendar-status]");

    root.querySelector("[data-scw-calendar-prev]").addEventListener("click", function () {
      state.visibleMonth = new Date(state.visibleMonth.getFullYear(), state.visibleMonth.getMonth() - 1, 1);
      render(root, state);
    });

    root.querySelector("[data-scw-calendar-next]").addEventListener("click", function () {
      state.visibleMonth = new Date(state.visibleMonth.getFullYear(), state.visibleMonth.getMonth() + 1, 1);
      render(root, state);
    });

    root.querySelector("[data-scw-calendar-today]").addEventListener("click", function () {
      var now = new Date();
      state.visibleMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      render(root, state);
    });

    search.addEventListener("input", function () {
      state.query = search.value || "";
      render(root, state);
    });

    fetch(dataUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Release calendar data failed to load.");
        return response.json();
      })
      .then(function (data) {
        state.releases = Array.isArray(data.releases) ? data.releases : [];
        updated.textContent = formatUpdated(data.generatedAt);
        var selectCategory = function (category) {
          state.activeCategory = category;
          renderCategories(root, state.releases, state.activeCategory, selectCategory);
          render(root, state);
        };
        renderCategories(root, state.releases, state.activeCategory, selectCategory);
        render(root, state);
      })
      .catch(function () {
        updated.textContent = "Last updated: unavailable";
        status.textContent = "Release calendar data is temporarily unavailable.";
        root.querySelector("[data-scw-calendar-list]").innerHTML = "";
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-scw-release-calendar]").forEach(init);
  });
})();
